import React, { useContext } from 'react';
import { Context } from '../../store/reducer';
import { id2Icon, dorokiseiIcon, legendArrays, accordionMenuIcons } from './config';
import infoIcon from '../../assets/img/icon_info.png';

const Component = ({ menuName, options, activeLabel,category }) => {
    const { state, dispatch } = useContext(Context);
    
    const legendSubTitle = (subTitle) => {
        return (subTitle &&
          <>
              <li>{subTitle}</li>
          </>
        )
    }


  /**
   * 左メニューに以下のメニューを表示する。
   * アイコンなし  + テキスト + アコーディオンによるアイコン付凡例
   * @param option
   * @returns {JSX.Element}
   */
  const textMenuWithIcon = (option) => {

    return (<li>
      <div className="gnav-list-ac">
        <p className="f-check" key={option.label}>
          <input type="checkbox"
                 id={option.id}
                 checked={state[option.id].checked}
                 onChange={() => dispatch({
                   type    : 'TOGGLE_CHECKED',
                   category: option.id
                 })}/>
          <label htmlFor={option.id}>

            {option.menuIcon &&
            <span className="icon-marker"><img src={id2Icon[option.id]} alt={option.label}/></span>
            }
            {option.legendColorClass &&
              <span className={"icon-marker icon-no " + option.legendColorClass}></span>
            }

            {/* メニューを色コードの直接指定で表示する。 */}
            {option.menuDisplayType && option.menuDisplayType === "bgColorCodeAndText" &&
              <span className={"icon-marker"} style={{background: option.color}}></span>
            }
            
              <span className="icon-name">
        
                {/* 改行を有効にするため改行コードでsplit */}
                {option.label.split('\n').map(t => (<>{t}<br /></>))}
              </span>
          </label>
        </p>
      </div>
    </li>)

  }

    
  /**
   * 左メニューに以下のメニューを表示する。
   * アイコンなし  + テキスト + アコーディオンによるアイコン付凡例
   * @param option
   * @returns {JSX.Element}
   */
  const textMenuWithLegend = (option) => {

      return (<li>
        <div className="gnav-list-ac">
          <p className="f-check" key={option.label}>
            <input type="checkbox" 
                   id={option.id} 
                   checked={state[option.id].checked}
                   onChange={() => dispatch({
                     type    : 'TOGGLE_CHECKED',
                     category: option.id
                   })}/>
            <label htmlFor={option.id}>

              {option.menuIcon &&
                <span className="icon-marker"><img src={id2Icon[option.id]} alt={option.label}/></span>
              }
              {option.legendColorClass &&
                <span className={"icon-marker icon-no " + option.legendColorClass}></span>
              }
              
              <span className="icon-name">
        
                {/* 改行を有効にするため改行コードでsplit */}
                {option.label.split('\n').map(t => (<>{t}<br /></>))}
              </span>
            </label>
          </p>

          <>
            <div class="ac-item ac-hanrei"></div>
            <ul class="ac-hanrei-list">
              {accordionMenuIcons[option.id].map(legend =>
                <li>
                  <div class="icon-wrap">
                    {
                      legend.img && <span className="icon-marker">
                      <img src={legend.img} alt={legend.label}/>
                      </span>
                    }
                    {legend.class && <span class={"icon-marker icon-no " + legend.class}></span>}
                    <span className="icon-name is-low">
                      {/* 改行を有効にするため改行コードでsplit */}
                      {legend.label.split('\n').map(t => (<>{t}<br /></>))}
                    </span>
                  </div>
                </li>)}
            </ul>
          </>
          
        </div>
      </li>)
      
    }

  /**
   * 左メニューのテキスト＋色表示の凡例
   * @param option
   * @returns {JSX.Element}
   */
  const textMenuWithColorLegend = (option) => {

    return (<li>
      <div className="gnav-list-ac">
        <p className="f-check" key={option.label}>
          <input type="checkbox"
                 id={option.id}
                 checked={state[option.id].checked}
                 onChange={() => dispatch({
                   type    : 'TOGGLE_CHECKED',
                   category: option.id
                 })}/>
          <label htmlFor={option.id}>
              <span className="icon-name">
        
                {/* 改行を有効にするため改行コードでsplit */}
                {option.label.split('\n').map(t => (<>{t}<br /></>))}
              </span>
          </label>
        </p>

        <>
          <div class="ac-item ac-hanrei"></div>
          <ul class="ac-hanrei-list">
            {accordionMenuIcons[option.id].map(legend =>
              <li>
                <div className="ac-hanrei-item">
                  <span className={"icon-marker icon-no " + legend.class}></span>
                  <span className="icon-name">{legend.label}</span></div>
              </li>
            )}
          </ul>
        </>

      </div>
    </li>)

  }

  /**
   * 法規制マップ 森林法専用のメニュー
   * @param option
   * @returns {JSX.Element}
   */
  const creteLayer90_5_menu = (option) => {
    
    const dispatch_toggle_90_5 = (e) => {

      dispatch({type    : 'SET_CHECKED', category: "vis_90_5", show: e.target.checked})
      
      dispatch({type    : 'SET_CHECKED', category: "vis_90_5_1", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_5_2", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_5_3", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_5_4", show: e.target.checked})
    }
    
    return (<li>
      <div className="gnav-list-ac">
        <p className="f-check" key={option.label}>
          <input type="checkbox"
                 id={option.id}
                 checked={state[option.id].checked}
                 onChange={(e) => dispatch_toggle_90_5(e)}/>
          <label htmlFor={option.id}>

            {option.menuIcon &&
              <span className="icon-marker"><img src={id2Icon[option.id]} alt={option.label}/></span>
            }
            {option.legendColorClass &&
              <span className={"icon-marker icon-no " + option.legendColorClass}></span>
            }

            <span className="icon-name">
        
                {/* 改行を有効にするため改行コードでsplit */}
              {option.label.split('\n').map(t => (<>{t}<br /></>))}
              </span>
          </label>
        </p>

        <>
          <div className="ac-item ac-hanrei"></div>
          <ul className="ac-hanrei-list is-low">
            {option.subLayers.map(subLayer =>
              <li>
                <p className="f-check">
                  <input type="checkbox"
                         id={subLayer.id}
                         checked={state[subLayer.id].checked}
                         onChange={() => dispatch({
                           type    : 'TOGGLE_CHECKED',
                           category: subLayer.id
                         })}/>
                  <label htmlFor={subLayer.id}>
                    <span className={"icon-marker icon-no " + subLayer.legendColorClass}></span>
                    <span className="icon-name is-low">{subLayer.label}</span>
                  </label>
                </p>
              </li>
            )}

            {accordionMenuIcons["vis_90_5"].map(legend =>
              <li className="text-only">                 
                {/* 改行を有効にするため改行コードでsplit */}
                {legend.label.split('\n').map(t => (<>{t}<br /></>))}
              </li>)}
            
          </ul>
        </>

      </div>
    </li>)

  }
  
  /**
   * 法規制マップ 河川法専用のメニュー
   * @param option
   * @returns {JSX.Element}
   */
  const creteLayer90_9_menu = (option) => {

    const dispatch_toggle_90_9 = (e) => {

      dispatch({type    : 'SET_CHECKED', category: "vis_90_9", show: e.target.checked})

      dispatch({type    : 'SET_CHECKED', category: "vis_90_9_1", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_9_2", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_9_3", show: e.target.checked})
    }

    return (<li>
      <div className="gnav-list-ac">
        <p className="f-check" key={option.label}>
          <input type="checkbox"
                 id={option.id}
                 checked={state[option.id].checked}
                 onChange={(e) => dispatch_toggle_90_9(e)}/>
          <label htmlFor={option.id}>

            {option.menuIcon &&
              <span className="icon-marker"><img src={id2Icon[option.id]} alt={option.label}/></span>
            }
            {option.legendColorClass &&
              <span className={"icon-marker icon-no " + option.legendColorClass}></span>
            }

            <span className="icon-name">
        
                {/* 改行を有効にするため改行コードでsplit */}
              {option.label.split('\n').map(t => (<>{t}<br /></>))}
              </span>
          </label>
        </p>

        <>
          <div className="ac-item ac-hanrei"></div>
          <ul className="ac-hanrei-list is-low">
            {option.subLayers.map(subLayer =>
              <li>
                <p className="f-check">
                  <input type="checkbox"
                         id={subLayer.id}
                         checked={state[subLayer.id].checked}
                         onChange={() => dispatch({
                           type    : 'TOGGLE_CHECKED',
                           category: subLayer.id
                         })}/>
                  <label htmlFor={subLayer.id}>
                    <span className={"icon-marker icon-no " + subLayer.legendColorClass}></span>
                    <span className="icon-name is-low">{subLayer.label}</span>
                  </label>
                </p>
              </li>
            )}

            {accordionMenuIcons["vis_90_9"].map(legend =>
              <li className="text-only">
                {/* 改行を有効にするため改行コードでsplit */}
                {legend.label.split('\n').map(t => (<>{t}<br /></>))}
              </li>)}

          </ul>
        </>

      </div>
    </li>)

  }


  /**
   * 法規制マップ 文化財保護法専用のメニュー
   * @param option
   * @returns {JSX.Element}
   */
  const creteLayer90_11_menu = (option) => {

    const dispatch_toggle_90_11 = (e) => {

      dispatch({type    : 'SET_CHECKED', category: "vis_90_11", show: e.target.checked})

      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_1", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_2", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_3", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_4", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_5", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_6", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_7", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_8", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_9", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_10", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_11", show: e.target.checked})
      dispatch({type    : 'SET_CHECKED', category: "vis_90_11_12", show: e.target.checked})
    }

    return (<li>
      <div className="gnav-list-ac">
        <p className="f-check" key={option.label}>
          <input type="checkbox"
                 id={option.id}
                 checked={state[option.id].checked}
                 onChange={(e) => dispatch_toggle_90_11(e)}/>
          <label htmlFor={option.id}>

            {option.menuIcon &&
              <span className="icon-marker"><img src={id2Icon[option.id]} alt={option.label}/></span>
            }
            {option.legendColorClass &&
              <span className={"icon-marker icon-no " + option.legendColorClass}></span>
            }

            <span className="icon-name">
        
                {/* 改行を有効にするため改行コードでsplit */}
              {option.label.split('\n').map(t => (<>{t}<br /></>))}
              </span>
          </label>
        </p>

        <>
          <div className="ac-item ac-hanrei"></div>
          <ul className="ac-hanrei-list is-low">
            {option.subLayers.map(subLayer =>
              <li>
                <p className="f-check">
                  <input type="checkbox"
                         id={subLayer.id}
                         checked={state[subLayer.id].checked}
                         onChange={() => dispatch({
                           type    : 'TOGGLE_CHECKED',
                           category: subLayer.id
                         })}/>
                  <label htmlFor={subLayer.id}>
                    {subLayer.menuIcon &&
                      <span className="icon-marker"><img src={id2Icon[subLayer.id]} alt={subLayer.label}/></span>
                    }
                    {subLayer.legendColorClass &&
                      <span className={"icon-marker icon-no " + subLayer.legendColorClass}></span>
                    }
                    <span className="icon-name is-low">{subLayer.label}</span>
                  </label>
                </p>
              </li>
            )}

            {accordionMenuIcons["vis_90_11"].map(legend =>
              <li className="text-only">
                {/* 改行を有効にするため改行コードでsplit */}
                {legend.label.split('\n').map(t => (<>{t}<br /></>))}
              </li>)}

          </ul>
        </>

      </div>
    </li>)

  }


  return (
        <div className="gnav-list-ac is-line">
            {
              category.useAccordion && <p className={options.length === 0 ? "f-check" : "gnav-category-ttl"}>
                {options.length === 0 && <input type="checkbox" id={menuName} name="" />}
                <label htmlFor={menuName} >
                  {menuName}
                </label>
              </p>
            }

            {options.length > 0 ?
                <>
                  {
                    category.useAccordion && <div className={category.activateAccordion ? "ac-item is-active" : "ac-item"}></div>
                  }
                  
                  	{/* アコーディオンを開いた状態にするかどうか。アコーディオン自体を使うかどうかで少し判定が複雑なので注意 */}
                    <ul style={
                      category.useAccordion 
                        ? category.activateAccordion ? {display:"block"} : {}
                        : {display:"block"}}>
                        
                      {options.map(option => {

                            
                            if (["sekisetusin_6_10", 
                              "vis_66", 
                              "vis_87",
                              "vis_32",
                              "vis_34",
                              "vis_36",
                              "vis_38",
                              "vis_39",
                              "vis_90_1",
                              "vis_90_2",
                              "vis_90_3",
                              "vis_90_4",
                              
                              "vis_90_6",
                              "vis_90_7",
                              "vis_90_8",
                              "vis_90_10",
                              "vis_90_12",
                              "vis_90_13",
                              "vis_90_14",
                              "vis_100",
                            ].includes(option["id"])) {
                              // テキスト + アイコン画像のアコーディオンのメニュー(一部メニューのみ汎用化対応)
                              return textMenuWithLegend(option)
                            } else if (["vis_63_1", "vis_91"].includes(option["id"])) {
                              // テキスト + 色表示のアコーディオンのメニュー(一部メニューのみ汎用化対応)
                              return textMenuWithColorLegend(option)
                            } else if ([
                              "vis_90_5",].includes(option["id"])) {
                              // テキスト + アイコンのメニュー(一部メニューのみ汎用化対応)
                              return creteLayer90_5_menu(option)
                            } else if ([
                              "vis_90_9",].includes(option["id"])) {
                              // 河川法 テキスト + アイコンのメニュー(一部メニューのみ汎用化対応)
                              return creteLayer90_9_menu(option)
                            } else if ([
                              "vis_90_11",].includes(option["id"])) {
                              // 文化財保護法 テキスト + アイコンのメニュー(一部メニューのみ汎用化対応)
                              return creteLayer90_11_menu(option)
                            } else if (option["menuDisplayType"] && option["menuDisplayType"] === "bgColorCodeAndText") {
                              // optionにmenuDisplayType:bgColorAndTextがあれば色＋テキストを表示する。
                              return textMenuWithIcon(option)
                            }
                            
                            return (
                                <>
                                    {(option["id"] == "85_1_8" && state.menu[option["id"]] == false) || 
                                    (option["id"] == "85_1_9" && state.menu[option["id"]] == false) ||
                                    (option["id"] == "85_1_10" && state.menu[option["id"]] == false) ||
                                    (option["id"] == "85_2" && state.menu[option["id"]] == false) ||
                                    (option["id"] == "85_3" && state.menu[option["id"]] == false) ?
                                        null : 
                                      
                                        // 判定式に注意。条件以外のものがここにくる
                                      
                                        (<>
                                            {["76_doseki_ryuiki", "76_jisuberi_kikenkasyo", "76_kyukeisya_kikenkasyo"].includes(option.id) &&
                                                <li>{option.subTitle}</li>
                                            }
                                            
                                            <li>
                                                <div class="gnav-list-ac">
                                                <p className={option.checkboxDisabled ? "" : "f-check"} key={option.label}>
                                                  {
                                                    // 準備中のチェックボックスなし表示に対応したチェックボックスの表示
                                                    (!option.checkboxDisabled) && <input type="checkbox" id={option.id} checked={state[option.id].checked} onChange={()=>dispatch({
                                                      type: 'TOGGLE_CHECKED',
                                                      category: option.id
                                                    })} />
                                                  }
                                                    
                                                    <label htmlFor={option.id}>
                                                      
                                                        {/* markerの場合、左メニューでチェックボックスの右にマーカーアイコン画像を表示する*/}
                                                        {option.type == "marker" && 
                                                            ((option.id == "dorokisei_1"||
                                                                option.id == "dorokisei_2"||
                                                                option.id == "dorokisei_3"||
                                                                option.id == "dorokisei_4"||
                                                                option.id == "dorokisei_5") ? null : <span className="icon-marker"><img src={id2Icon[option.id]} alt={option.label}/></span>)}

                                                        {/* vectorの場合、左メニューでチェックボックスの右に背景色だけの四角を出している処理 */}
                                                        {option.type == "vector" && 
                                                            ((option.id == "kasen" || 
                                                                option.id == "kasen-saidai" || 
                                                                option.id == "tsunami" || 
                                                                option.id == "takashio" || 
                                                                option.id == "takashio-isewan" || 
                                                                option.id == "takashio-saidai" ||
                                                                option.id == "kasen-keizoku" ||
                                                            option.id == "toshi_85_1_11" ||
                                                              option.id == "vis_95_1" ||
                                                              option.id == "vis_95_2" ||
                                                              option.id == "vis_95_3" ||
                                                              option.id == "vis_95_4" ||
                                                              option.id == "vis_95_5" ||
                                                              option.id == "vis_95_6" ||
                                                            option.id == "85_2_1_land_250m"||
                                                            option.id == "85_2_2_land_town"||
                                                            option.id == "85_2_3_land_site"||
                                                            option.id == "85_3_1_building_250m"||
                                                              option.id == "85_3_2_building_town"||
                                                              option.id == "85_3_3_building_building" ||
                                                                option.id == "85_4_1_population_500m" ||
                                                                option.id == "85_4_2_population_town") ? null : <span class={"icon-marker icon-no " + option.legendColorClass}></span>)}
                                                            
                                                            <span className="icon-name">
        
                                                                {/* メニューのチェックボックスとアイコン画像が表示されているエリア */}
                                                                {/* 改行を有効にするため改行コードでsplit */}
                                                                {option.label.split('\n').map(t => (<>{t}<br /></>))}
                                                            </span>

                                                    </label>
                                                </p>
                                                
                                                {(option.id == "kasen" || 
                                                    option.id == "kasen-saidai" ||
                                                    option.id == "kasen-keizoku" ||
                                                    option.id == "vis_95_1" ||
                                                    option.id == "vis_95_2" ||
                                                    option.id == "vis_95_3" ||
                                                    option.id == "vis_95_4" ||
                                                    option.id == "vis_95_5" ||
                                                    option.id == "vis_95_6" ||
                                                    option.id == "tsunami" || 
                                                    option.id == "takashio" || 
                                                    option.id == "takashio-isewan" || 
                                                    option.id == "takashio-saidai" ||
                                                    option.id == "toshi_85_1_11") &&
                                                        <>
                                                            <div class="ac-item ac-hanrei"></div>
                                                            <ul class="ac-hanrei-list">
                                                                {legendArrays[option.id].map(legend => {
                                                                    
                                                                        return (
        
                                                                        <>
                                                                        {legendSubTitle(legend.subTitle)}
                                                                        <li>
                                                                          <hr />
                                                                        </li>
                                                                        <li>
                                                                            <div class="ac-hanrei-item"><span
                                                                            class={"icon-marker icon-no " + legend.class}
                                                                            style={{background: legend.color}}></span><span
                                                                            class="icon-name">{legend.range}</span></div>
                                                                        </li>
                                                                        </>
                                                                        )
                                                                    }
                                                                )}   
                                                            </ul>
                                                        </>}

                                                  
                                                  {(option.id == "85_2_1_land_250m" ||
                                                      option.id == "85_2_2_land_town" ||
                                                      option.id == "85_2_3_land_site" ||
                                                      option.id == "85_3_1_building_250m" ||
                                                      option.id == "85_3_2_building_town" ||
                                                      option.id == "85_3_3_building_building" ||
                                                      option.id == "85_4_1_population_500m" ||
                                                      option.id == "85_4_2_population_town") &&
                                                    <>
                                                      <div class="ac-item ac-hanrei"></div>
                                                      <ul class="ac-hanrei-list">
                                                        {legendArrays[option.id].map(legend => {

                                                            return (

                                                              <>
                                                                {legendSubTitle(legend.subTitle)}
                                                                <li>
                                                                  <div class="ac-hanrei-item"><span
                                                                    class={"icon-marker icon-no " + legend.class}
                                                                    style={{background: legend.color}}></span><span
                                                                    class="icon-name">{legend.range}</span></div>
                                                                </li>
                                                              </>
                                                            )
                                                          }
                                                        )}
                                                      </ul>
                                                    </>}
                                                  
                                                {(option.id == "dorokisei_1"||
                                                    option.id == "dorokisei_2"||
                                                    option.id == "dorokisei_3"||
                                                    option.id == "dorokisei_4"||
                                                    option.id == "dorokisei_5") &&
                                                        <>
                                                            <div class="ac-item ac-hanrei"></div>
                                                            <ul class="ac-hanrei-list">     
                                                                {dorokiseiIcon[option.id].map(dorokisei => 
                                                                    <li>
                                                                        <div class="icon-wrap">
                                                                            {dorokisei.img && <span className="icon-marker"><img src={dorokisei.img} alt={dorokisei.label}/></span>}
                                                                            {dorokisei.class && <span class={"icon-marker icon-no " + dorokisei.class}></span>}
                                                                            <span className="icon-name is-low">
                                                                                {/* 改行を有効にするため改行コードでsplit */}
                                                                                {dorokisei.label.split('\n').map(t => (<>{t}<br /></>))}
                                                                            </span>
                                                                        </div>
                                                                    </li>)}                                                           
                                                            </ul>
                                                        </>}         
                                                </div>
                                            </li>

                                            {option.id == "kouwan_30_4" || option.id == "kouwan_30_7" ? 
                                                <li>
                                                    <div class="icon-wrap">
                                                        <span className="icon-marker icon-no h-road-i-closed"></span>
                                                        <span className="icon-name">該当箇所</span>
                                                    </div>
                                                </li> : null}
                                        </>)
                                    }
                                </> 
                            )
                        })}
                    </ul>
                </> : null}
        </div>
    );
};

export default Component;
